module.exports = __webpack_public_path__ + "static/img/icon_logo.bb6323b3.png";